import { TState } from '../store/dimensions';

export const getFormattedCalculateParams = (calculateParams: TState) => ({
  ...calculateParams,
  checkedProducts: calculateParams.complimentaryProductInfo.length
    ? calculateParams.complimentaryProductInfo.map(item => ({
        id: item.productId,
        isChecked: true,
      }))
    : [],
});
